import AlertBox from "./AlertBox"

export default AlertBox;